/* eslint-disable */
import React, { lazy, Suspense } from 'react';
/* eslint-disable */
import ReactDOM from 'react-dom';
// react library for routing
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

// plugins styles from node_modules
import 'react-notification-alert/dist/animate.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
// plugins styles downloaded
import 'assets/vendor/fullcalendar/dist/fullcalendar.min.css';
import 'assets/vendor/sweetalert2/dist/sweetalert2.min.css';
import 'assets/vendor/select2/dist/css/select2.min.css';
import 'assets/vendor/quill/dist/quill.core.css';
import 'assets/vendor/nucleo/css/nucleo.css';
import 'assets/vendor/@fortawesome/fontawesome-free/css/all.min.css';
// core styles
import 'assets/scss/argon-dashboard-pro-react.scss?v1.0.0';

const AdminLayout = lazy(() => import('layouts/partner.jsx'));
const AuthLayout = lazy(() => import('layouts/Auth.jsx'));
const IndexView = lazy(() => import('views/Index.jsx'));
const Payment = lazy(() => import('./views/pages/Payment'));

ReactDOM.render(
  <BrowserRouter>
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <Route path="/partner" render={(props) => <AdminLayout {...props} />} />
        <Route path="/payment" render={(props) => <Payment {...props} />} />
        <Route
          exact
          path="/auth/join"
          render={(props) => <Payment {...props} />}
        />
        <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        <Redirect from="*" to="/auth/join" />
      </Switch>
    </Suspense>
  </BrowserRouter>,
  document.getElementById('root'),
);
